import type { UserProfile } from "@/lib/types";

export function isFocusModeEnabled(profile?: UserProfile | null): boolean {
  return profile?.feature_focus_mode_enabled === true;
}

export function isFeedbackDigestEmailEnabled(profile?: UserProfile | null): boolean {
  return profile?.email_notify_feedback_digest === true;
}

export function isAccessRequestEmailEnabled(profile?: UserProfile | null): boolean {
  return profile?.email_notify_access_requests === true;
}
